module.exports = __webpack_public_path__ + "images/building-icon-a2c43db14f8aa3c4071e3f9196dc00c6.svg";